
<div class="input-container">
  <app-users-dropdown *ngIf="taggable && isDropdownOpened"
    #usersDropdown
    [users]="taggableList"
    [search]="usernameSearch"
    (chooseUser)="onUserChosen($event)"
  ></app-users-dropdown>
  <div class="input" #input
    contenteditable="true"
    [attr.placeholder]="placeholder"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
  ></div>
  <button
    pButton
    type="button"
    class="p-button-text p-button-rounded p-button-icon-only send-button"
    icon="icon-send"
    (click)="onClickSend(input.innerText)"
  ></button>
</div>
